import { ADD_TIMEOUT_ID, CLEAR_ALL_IDS, REMOVE_TIMEOUT_ID, SET_ALERT_SETTINGS } from '../actions/alert';
import { TYPES } from '../actions/modal';
import { LOGOUT } from '../actions/screen';

export const AlertType = {
    ALTITUDE: 'ALTITUDE',
    FUEL: 'FUEL',
};

export const PopupType = {
    [AlertType.ALTITUDE]: TYPES.CHECK_ALTITUDE,
    [AlertType.FUEL]: TYPES.SHORT_POINT,
};

export const DefaultIsAlertAllowed = {
    [AlertType.ALTITUDE]: false,
    [AlertType.FUEL]: false,
};

export const DefaultIntervalValue = {
    [AlertType.ALTITUDE]: 60,
    [AlertType.FUEL]: 30,
};

const DefaultTimeoutID = {
    [AlertType.ALTITUDE]: {},
    [AlertType.FUEL]: {},
};

const DefaultNextAlert = {
    [AlertType.ALTITUDE]: {},
    [AlertType.FUEL]: {},
};

const initialState = {
    interval: DefaultIntervalValue,
    allowed: DefaultIsAlertAllowed,
    timeoutID: DefaultTimeoutID,
    nextAlert: DefaultNextAlert,
};

export default (state = initialState, action) => {
    const { type, legId, timeoutId, date } = action.alert || {};
    const updatedTimeoutID = { ...state.timeoutID };
    const nextAlert = { ...state.nextAlert };

    const removeTimeoutID = (type, legId) => {
        if (updatedTimeoutID[type] && updatedTimeoutID[type][legId]) {
            clearTimeout(updatedTimeoutID[type][legId]);
            delete updatedTimeoutID[type][legId];
            delete nextAlert[type][legId];
        }
    };

    switch (action.type) {
        case SET_ALERT_SETTINGS:
            return {
                ...state,
                interval: action.setting.interval,
                allowed: action.setting.allowed,
            };
        case ADD_TIMEOUT_ID:
            if (updatedTimeoutID[type][legId]) {
                clearTimeout(updatedTimeoutID[type][legId]);
            }
            updatedTimeoutID[type][legId] = timeoutId;
            nextAlert[type][legId] = date;

            return {
                ...state,
                timeoutID: updatedTimeoutID,
            };
        case REMOVE_TIMEOUT_ID:
            removeTimeoutID(type, legId);

            return {
                ...state,
                timeoutID: updatedTimeoutID,
            };
        case CLEAR_ALL_IDS:
            Object.keys(updatedTimeoutID).forEach((type) => {
                removeTimeoutID(type, legId);
            });

            return {
                ...state,
                timeoutID: updatedTimeoutID,
            };

        case LOGOUT:
            Object.keys(updatedTimeoutID).forEach((type) => {
                Object.keys(updatedTimeoutID[type]).forEach((legId) => {
                    removeTimeoutID(type, legId);
                });
            });

            return initialState;
        default:
            return state;
    }
};
